import { RootState } from "../../rootReducer";

export const selectIsDeletingStressCheck = (state: RootState) =>
  state.stressDepartmentList.loading;
export const selectDeleteErrorMessage = (state: RootState) =>
  state.stressDepartmentList.error;
export const departmentListDataResponse = (state: RootState) =>
  state.stressDepartmentList.stressDepartmentListResponse;
